import { QuestionActions } from '../actions/question-action-creators.mjs';
import { NavigationActions } from '../actions/navigation-action-creators.mjs';
import { ValidationActions } from '../actions/validation-action-creators.mjs';
import extractValidationErrorsFromPageResponse from '../page/extractValidationErrorsFromPageResponse.mjs';

const validationReducer = (state, action) => {
  if (action.type === QuestionActions.VALIDATION_STATE_CHANGED) {
    const {
      errors,
      question,
      questionGroup,
      groupErrors,
      local,
      shouldDisplay = true
    } = action;
    if (local) {
      const validationErrors = (state.validationErrors || []).filter(
        e => (e.fieldType === 'question' && e.key !== question.appkey) ||
          (e.fieldType === 'questionGroup' && e.key !== questionGroup.key));

      if (errors) {
        validationErrors.push({
          fieldType: 'question',
          questionType: action.question.attributes && action.question.attributes.format ? action.question.attributes.format : action.question.format ? action.question.format : null ,
          key: action.question.appkey,
          shouldDisplay,
          errors
        });
      }

      if (groupErrors) {
        validationErrors.push({
          fieldType: 'questionGroup',
          questionType: action.question.attributes && action.question.attributes.format ? action.question.attributes.format : action.question.format ? action.question.format : null ,
          key: questionGroup.key,
          shouldDisplay,
          errors: groupErrors
        });
      }

      return {
        ...state,
        validationErrors
      };
    }
  } else if (action.type === ValidationActions.VALIDATION_STATE_SHOW) {
    if (action.local && action.shouldDisplay) {
      const validationErrors = (state.validationErrors || []);

      const showValidationErrors = entries => entries.map(e => ({...e, shouldDisplay: true}));

      return {
        ...state,
        validationErrors: showValidationErrors(validationErrors)
      };
    }
  } else if (action.type === NavigationActions.PAGE_REQUEST_COMPLETED) {
    const validationErrors = extractValidationErrorsFromPageResponse(action.nextPage);

    return {
      ...state,
      validationErrors
    };
  }

  return state;
};

export default validationReducer;
